import React, { useEffect, useState } from "react";

import css from "../css/Home.css";
import CardComponent from "./CardComponent";
import blob from "../images/blob.svg";
import introImage from "../images/introImage.png";
import myImage from "../images/myImage.png";
import TypeWriterEffect from "react-typewriter-effect";
import MySkills from "./MySkills";
import { Divider } from "@material-ui/core";
import ContactMe from "./ContactMe";
import AboutMe from "./AboutMe";
import Fade from "react-reveal/Fade";
import Bounce from "react-reveal/Bounce";
import Slide from "react-reveal/Slide";
import Header from "./Header";
import Experince from "./Experince";
import { collection, getDocs, getFirestore } from "../firebase";

function Home() {
  const [experince, setExperince] = useState([]);
  
  // Services data
  const services = [
    {
      title: "Mobile App Development",
      description: "Building cross-platform mobile applications using React Native with smooth UI/UX and native performance.",
      icon: "📱" // You can replace with an actual icon component or image
    },
    {
      title: "Web Development",
      description: "Creating responsive and interactive web applications using modern frameworks like React.js and Next.js.",
      icon: "🌐" // You can replace with an actual icon component or image
    },
    {
      title: "Backend Development",
      description: "Developing robust server-side applications, APIs, and databases using Node.js, Express, and Firebase.",
      icon: "⚙️" // You can replace with an actual icon component or image
    }
  ];

  useEffect(() => {
    getExperince();
  }, []);

  const getExperince = async () => {
    const firestore = getFirestore();
    const experinceColl = collection(firestore, "experince");
    const docs = await getDocs(experinceColl);

    docs.forEach((doc) => {
      setExperince([doc.data()]);
    });
  }

  return (
    <div>
      <div className="homeTop">
        <Slide down>
          <Header />
        </Slide>

        <Fade left>
          <div className="homeTopCenter">
            <div className="centerLeft">
              <h1>Hi, I'm a</h1>
              <span>
                <TypeWriterEffect
                  textStyle={{
                    fontSize: 30,
                  }}
                  startDelay={100}
                  cursorColor="#3F3D56"
                  multiText={[
                    "Full Stack Web Developer",
                    "Mobile App Developer",
                    "Software Engineer",
                  ]}
                  typeSpeed={90}
                />
              </span>
              <p>
                Bad programmers worry about the code.<br></br>
                Good programmers worry about data structures<br></br> and their
                relationships
              </p>

              <div className="btns">
                <a className="btnContact" href="#contact">
                  Contact Me
                </a>
                <a
                  className="btnCv"
                  target="__blank"
                  href="https://drive.google.com/u/0/uc?id=1LOX1uq-TRzCF-h_HebWP3oTGvXNjOTAH&export=download"
                >
                  Download Cv
                </a>
              </div>
            </div>

            <div className="centerRight">
              {/* <img src={introImage} alt="" srcset="" /> */}
              {/* <img className="myImage" src={myImage} alt="" srcset="" />
              <img className="blobImage" src={blob} alt="" srcset="" /> */}
            </div>
          </div>
        </Fade>

        {/* My Skills Section */}
        <div className="mySkills">
          <Slide left>
            <MySkills />
          </Slide>
        </div>

        {/* Services Section */}
        <div className="servicesSection">
          <Slide right>
            <div className="servicesContainer">
              <h1 className="sectionTitle">My Services</h1>
              <div className="servicesGrid">
                {services.map((service, index) => (
                  <div key={index} className="serviceCard">
                    <div className="serviceIcon">{service.icon}</div>
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </Slide>
        </div>

        {/* Experience Section */}
        <div className="Experince">
          <Slide right>
            <h1>Experince</h1>
            {experince.length > 0
              ? experince.map((experince, index) => {
                  return (
                    <Experince 
                      key={index}
                      company={experince.company} 
                      role={experince.role} 
                      desc={experince.desc} 
                      logo={experince.logo}
                    />
                  );
                })
              : ""}
          </Slide>
        </div>

        {/* About Me Section */}
        <div className="aboutMe" id="aboutMe">
          <Slide left>
            <AboutMe />
          </Slide>
        </div>
      </div>
    </div>
  );
}

export default Home;